export default "/images/PeerDirect.svg?e15a8ed0673b1644756df294e0f550b9";